import React from 'react'
import './Review.scss'
import { data } from '../../constants';

const ReviewBox = ({ review: { userImg, name, review1, review2 } }) => (

    <div className="box">

        <div className="user">

            <img src={userImg} alt="" />
            <div className="info">
                <h3>{name}</h3>
                <div className="stars">
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star-half-alt"></i>
                    <span>(4.5)</span>
                </div>
            </div>
            <i className="fas fa-quote-right"></i>
            
        </div>

        <p>{review1}</p>
        <p>{review2}</p>

    </div>
)

const Review = () => {
    return (
        <section className="review" id="review">

            <h1 className="heading">
                client's <span>Review</span>
            </h1>

            <div className="box-container">
                {
                    data.reviews.map((review, i) => (

                        <ReviewBox key={i} review={review} />

                    ))
                }
            </div>
        </section>
    )
}

export default Review